import React, { useState, useEffect } from "react";
import Select from "react-select";
// import ImageWithBasePath from "../../img/imagewithbasebath";
// import { Link } from "react-router-dom";
import {
  API_BASE_URL,
  // GET_STORE,
  GET_STOCK_TRANSFER_BY_ID,
  GET_USER_STORES,
  INSERT_TRANSFER_STOCK,
  UPDATE_TRANSFER_STOCK_STATUS,
  // GET_STOCK_INDENT,
  GET_STOCK_INDENT_LIST,
  GET_APPROVED_INDENTS_BY_STORE,
} from "../../../Config";
import Axios from "axios";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
// import jsPDF from 'jspdf';
// import html2pdf from 'html2pdf.js';
// import dayjs from 'dayjs';
// import UploadFiles from "../../../feature-module/UploadFiles";


const IndentStockTransferModal = ({ transferObj }) => {

  const [userDataSession, setUserDataSession] = useState([]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const [offcanvasWidth, setOffcanvasWidth] = useState("53%");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOffcanvasWidth("75%");
      } else {
        setOffcanvasWidth("45%");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [userStoresData, setUserStoresData] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [indentsDDL, setIndentsDDL] = useState([]);
  const [indentProductsData, setIndentProductsData] = useState([]);

  const [selectedUserStore, setSelectedUserStore] = useState(null);
  const [selectedDestinationStore, setSelectedDestinationStore] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedIndent, setSelectedIndent] = useState(null);
  const [productNotes, setProductNotes] = useState("");
  const [trackingDetails, setTrackingDetails] = useState("");
  const [btnSubLoading, setBtnSubLoading] = useState(false);
  const [transferProductsViewData, setTransferProductsViewData] = useState([]);
  const [addErrorMess, setAddErrorMess] = useState('');

  // const [tSId, setTSId] = useState('');

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && userDataSession.UserId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setUserStoresData(response.data.ResultData);
            setStoresData(response.data.ResultData);
            console.log(
              "Data fetched successfully store user data:",
              response.data.Message
            );
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
        const fetchFilterData = () => {
            if ( userDataSession && userDataSession.OrgId && (selectedDestinationStore)) {
              setLoading(true);
              let storeid = 0;
        
              if (selectedDestinationStore) {
                storeid = selectedDestinationStore.value;
              }

              const url = `${API_BASE_URL}${GET_APPROVED_INDENTS_BY_STORE}?OrgId=${userDataSession.OrgId}&StoreId=${storeid}`;
              console.log(url);
                      
              Axios.get(url)
                .then((response) => {
                    if (response.data.Status) {
                        setIndentsDDL(response.data.ResultData);
                        console.log(response.data)
                    } else {
                        console.error("Error fetching data:", response.data.Message);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                });
                }
            };
        fetchFilterData();
    }
  }, [userDataSession, selectedDestinationStore]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
            if (selectedIndent) {
                const fetchData = () => {
                  setLoading(true);
                  Axios.get(
                    `${API_BASE_URL}${GET_STOCK_INDENT_LIST}?OrgId=${userDataSession.OrgId}&IndentNo=${selectedIndent.value}`
                  )
                    .then((response) => {
                      if (response.data.Status) {
                        const resultDataWithQuantity = response.data.ResultData.map(
                            (item) => ({ ...item, Quantity: "" })
                        );
                        setIndentProductsData(resultDataWithQuantity);
                        setLoading(false);
                      } else {
                        console.error("Error fetching data:", response.data.Message);
                      }
                    })
                    .catch((error) => {
                      setLoading(false);
                      console.error("Error fetching data:", error);
                    });
                };
                fetchData();
            }
    }
  }, [userDataSession, selectedIndent]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      console.log(transferObj, "ttt ttt");
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_STOCK_TRANSFER_BY_ID}?OrgId=${userDataSession.OrgId}&TransactionId=${transferObj.TransferId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setTransferProductsViewData(response.data.ResultData);
            setLoading(false);
          } else {
            setLoading(false);
            console.error("Error fetching data:", response.data.ResultData);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession, transferObj]);

  const handleUserStoreChange = (selectedOption) => {
    setSelectedUserStore(selectedOption);
    // console.log(selectedDestinationStore, selectedUserStore, selectedIndent);
  };

  const handleDestinationStoreChange = (selectedOption) => {
    setSelectedDestinationStore(selectedOption);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date.target.value);
  };

  const handleIndentChange = (selectedOption) => {
    setSelectedIndent(selectedOption);
  };

  const handleDelete = (index) => {
    setIndentProductsData((prevData) =>
      prevData.filter((_, i) => i !== index)
    );
  };

  const handleQuantityChange = (index, newQuantity) => {
    setIndentProductsData((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, Quantity: newQuantity } : item
      )
    );
  };

  const handleSubmit = (status, event) => {
    if (event) event.preventDefault();
    setBtnSubLoading(true);

    if(!selectedDate) {
      setAddErrorMess('Please select tranfer date..');
      setBtnSubLoading(false);
      return;
    }

    if (!trackingDetails) { 
      setAddErrorMess('Please enter courier details..');
      setBtnSubLoading(false);
      return;
    }

    // Prepare the Stocktransfer part
    const stockTransferData = [
      {
        Id: 0,
        FromStoreId: selectedUserStore.value,
        ToStoreId: selectedDestinationStore.value,
        TransferRequestDate: new Date().toISOString().split("T")[0],
        TransferDate: selectedDate,
        Notes: productNotes,
        Status: status,
        TrackingDetails: trackingDetails,
        IndentNo: selectedIndent.value
      },
    ];

    // Prepare the productdetails part
    console.log(indentProductsData, "indentProductsData indentProductsData indentProductsData");
    const productDetailsData = indentProductsData.map((item) => ({
      DetailId: 0,
      ProductId: item.ProductId,
      ReqQuantity: item.ReqQty,
      UOM: "",
      Comments: item.Comments,
      TransferQty: item.Quantity,
      ReturnQty: 0,
    }));

    // Combine both parts into one payload
    const payload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      Stocktransfer: stockTransferData,
      productdetails: productDetailsData,
      IndentStatus: "0",
    };
    console.log(payload, "data sending to api for insert data");

    // Send the POST request
    Axios.post(`${API_BASE_URL}${INSERT_TRANSFER_STOCK}`, payload)
      .then((response) => {
        setBtnSubLoading(false);
        console.log(response.data, "response from service..");
        if (response.data[0].Success == 1) {
          setBtnSubLoading(false);
          Swal.fire({
            title: `Stock Transfer added Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          setBtnSubLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setBtnSubLoading(false);
        console.error(
          "Error submitting data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const handleReceiveBtnClick = (e) => {
    e.preventDefault();

    const requestData = {
      Id: `${transferObj.TSId}`,
    };

    console.log(requestData.Quantity, " formdata");

    Axios.post(`${API_BASE_URL}${UPDATE_TRANSFER_STOCK_STATUS}`, requestData)
      .then((response) => {
        if (response.data.ResultData[0]["Status"] == "1") {
          Swal.fire({
            title: `Stock Transfer added Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        console.error(
          "Error submitting data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2rem",
      height: "2.4rem",
    }),
  };
// console.log("tracking",transferObj?.TrackingDetails)
  return (
    <div>
      {/* Add Stock */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightIndentAddStockTrnsf"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: offcanvasWidth, maxWidth: '53%' }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel">Add Transfer By Indent</h4>
          
          <div className="d-flex">
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div >
            <form>
              <div className="row">
                <div className="col-lg-4">
                  <div className="input-blocks">
                    <label>Source Store<span className="fw-bold text-danger">*</span></label>
                    <Select
                      className="select"
                      onChange={handleUserStoreChange}
                      options={userStoresData.map((store) => ({
                        value: store.StoreId,
                        label: store.Name,
                      }))}
                      styles={customStyles}
                      placeholder="Choose from store"
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="input-blocks">
                    <label>Destination Store<span className="fw-bold text-danger">*</span></label>
                    <Select
                      className="select"
                      id="storeSelect"
                      onChange={handleDestinationStoreChange}
                      options={storesData.map((store) => ({
                        value: store.StoreId,
                        label: store.Name,
                      }))}
                      placeholder="Choose to store"
                      styles={customStyles}
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <label className="mb-2">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={handleDateChange}
                    value={selectedDate}
                    required
                  />
                </div>
                <div className="col-lg-12">
                  <div className="input-blocks search-form mb-0">
                    <label>Notes</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter notes"
                      value={productNotes}
                      onChange={(e) => {
                        setProductNotes(e.target.value);
                      }}
                      style={{ height: "4rem" }}
                    />
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <label className="form-label fw-bold">Tracking Details<span className="fw-bold text-danger">*</span></label>
                  <textarea
                    className="form-control "
                    placeholder="Enter courier details"
                    value={trackingDetails}
                    onChange={(e) => {
                        setTrackingDetails(e.target.value);
                      }}
                  ></textarea>
                </div>
                <p className="text-danger fw-bold">{addErrorMess}</p>
                <div className="col-lg-12 mt-2">
                  <div className="input-blocks">
                    <label>Indents to Add</label>
                    <Select
                      className="select"
                      id="storeSelect"
                      onChange={handleIndentChange}
                      options={indentsDDL.map((store) => ({
                        value: store.IndentNo,
                        label: store.IndentNo,
                      }))}
                      placeholder="Choose indent"
                      styles={customStyles}
                    />
                  </div>
                </div>
              </div>
              <div className="table-responsive" style={{ maxHeight: '20rem', overflowy: 'auto' }}>
                <table className="table datanew">
                  <thead>
                    <tr className="sticky-top">
                      <th>Product</th>
                      <th>Approved Qty</th>
                      <th>Transfered Qty</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {indentProductsData.length !== 0 ? (
                      indentProductsData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.ProductName}</td>
                          <td>{item.Approvedqty}</td>
                          <td>
                            <input
                                className="form-control"
                                type="number"
                                style={{ height: "2rem", width: "10rem" }}
                                placeholder="Enter quantity"
                                value={item.Quantity}
                                onChange={(e) =>
                                    handleQuantityChange(index, e.target.value)
                                }
                                onWheel={(e) => e.target.blur(e)}
                            />
                          </td>
                          <td>
                            <button
                              className="btn border text-danger"
                              onClick={() => handleDelete(index)}
                              type="button"
                            >
                              <i className="feather-trash-2 fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No Data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer-btn sticky-bottom">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-info"
                  onClick={() => handleSubmit("TRANSFERED")}
                >
                  {btnSubLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Add Stock */}

      {/* View Stock */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightIndView"
        aria-labelledby="offcanvasRightLabel"
        style={{ maxWidth: offcanvasWidth }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">
            View Transfer (ST-{transferObj?.AutoGenTransactionNo})
          </h4>
          <button
            className={`btn btn-success rounded me-3 ${transferObj.Status === 2 ? 'd-none' : 'd-block'}`}
            title="Receive Stock"
            type="button"
            onClick={handleReceiveBtnClick}
          >
            <i className="fa-solid fa-download fs-5"></i>
          </button>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <div id="pdf-content">
            <div className="d-flex">
              <h4>{transferObj.TransferOrder}</h4>
              <h4
                className={`ms-auto ${
                  transferObj.Status === 1
                    ? "text-warning"
                    : transferObj.Status === 2
                    ? "text-success"
                    : transferObj.Status === 3
                    ? "text-danger"
                    : ""
                }`}
              >
                {transferObj.Status === 1
                  ? "In Transit"
                  : transferObj.Status === 2
                  ? "Received"
                  : transferObj.Status === 3
                  ? "Canceled"
                  : ""}
              </h4>
            </div>
            <div className="d-flex my-2 table-responsive">
              <table className="table ">
                <thead>
                  <tr>
                    <th className="">Date</th>
                    <th className="">Source</th>
                    <th className="">Destination</th>
                    <th className="">Transfer by</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fw-bold">
                      {formatDate(transferObj?.TransferDate)}
                    </td>
                    <td className="fw-bold">{transferObj?.FromStore}</td>
                    <td className="fw-bold">{transferObj?.ToStore}</td>
                    <td className="fw-bold">{transferObj?.TransferBy}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="my-3">
              <label className="form-label fw-bold">Notes:</label>
              <textarea
                className="form-control "
                readOnly
                value={transferObj?.Notes}
              ></textarea>
            </div>
            <div className="row">
              <div className="">
                <label className="form-label fw-bold">Tracking Details:</label>
                <textarea
                  className="form-control "
                  value={transferObj?.TrackingDetails}
                  readOnly
                ></textarea>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table ">
                <thead>
                  <tr>
                    <th className="">#</th>
                    <th className="">Item</th>
                    <th className="">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{ position: "relative", height: "10px" }}
                      >
                        <div className="loader m-auto"></div>
                      </td>
                    </tr>
                  ) : (
                    transferProductsViewData?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="fw-bold">{item.ProductName}</td>
                        <td className="fw-bold">{item.ReqQuantity}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* <UploadFiles number={"PO1234"} type={"StockTrasnferIndent"} /> */}

    </div>
  );
};

IndentStockTransferModal.propTypes = {
  transferObj: PropTypes.object.isRequired,
};

export default IndentStockTransferModal;
